




















































import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import moment from 'moment'
import { dateWeekFormat } from '@/filters/dateFormat'

@Component({
  components: {}
})
export default class DatePicker extends Mixins(BaseVue) {
  @Prop() private label!: string
  @Prop() private name!: string
  @Prop() private date!: Date
  @Prop() private disabled!: boolean
  @Prop({ default: false })
  public clearable!: boolean

  @Prop({ default: '' })
  public rules!: string

  @Prop()
  public placeholder!: string

  @Prop()
  public small!: boolean

  @Prop({ default: '' })
  public min!: Date | string

  @Prop({ default: '' })
  public max!: Date | string

  private windowModal = false
  private value = ''
  private format = 'YYYY.MM.DD'

  private get minDate(): string {
    return moment(this.min).toISOString(true)
  }

  private get maxDate(): string {
    return moment(this.max).toISOString(true)
  }

  private get text(): string {
    if (this.date && moment(this.date).year() > 1900) {
      return moment(this.date).format(this.format)
    }

    return ''
  }

  private dateUpdated() {
    const newDate = moment(this.value).toDate()
    this.$emit('update:date', newDate)
  }

  private setWindowText(event: any) {
    let newDate: Date | undefined
    if (event.currentTarget.value) {
      const momentDate = moment(event.currentTarget.value)
      if (momentDate.isValid()) {
        newDate = momentDate.toDate()
      }
    }

    this.$emit('update:date', newDate)
    this.$emit('blur')
  }

  public get week() {
    return (this.value && !this.small)
      ? dateWeekFormat(this.value)
      : ''
  }
}
